// LICENSE_CODE ZON
'use strict'; /*jslint ts:true, browser:true, react:true*/
import React, {useContext, useEffect} from 'react';
import styles from './premium_popup.module.less';
import cn from 'classnames';
import {Settings_context} from '../settings_ctx';
import {Button} from '../../../shared/button';
import {perr} from 'hola_pub_util';
import {Default_banner, Form} from './login/form';

interface i_premium_popup_props {
    title: JSX.Element;
    ref_str: string;
}
export const Premium_popup = (props:i_premium_popup_props)=>{
    useEffect(()=>{
        perr({id: `www_premium_popup_${props.ref_str}_show`});
    }, []);
    const {theme, show_modal} = useContext(Settings_context);
    const on_login = event=>{
      event.preventDefault();
      show_modal('login_form', p=>{
          return <Form {...p}
            Banner={<Default_banner />}
            can_signup
            default_state={'login_buttons'}/>;
      }, {
        width: 736,
        paddingless: true,
        no_logo: true,
      });
  };
    return <div className={styles.abs_overlay}>
      <div className={styles.form}>
        <p className={cn(theme.bold, styles.dark)}>{props.title}</p>
        <Button color={'black2023'} caption={'Join Hola Premium'}
          on_click={()=>{
            location.href = `/premium?ref=${props.ref_str}`;
          }}/>
        <p className={cn(theme.p2, styles.link)}>
          <a href='/login' onClick={on_login}>I'm already a member</a>
        </p>
      </div>
    </div>;
};
